<template>
  <nav v-if="pageSize < totalItems"
       role="navigation" class="loyalty-table__pager" aria-label="Pagination Navigation">
    <button
      class="pager__prev"
      :disabled="currentPage === 1"
      :title="translate('lblLinkPrev')"
      @click="goToPreviousPage"
    ><arrow></arrow></button>
    <ul>
      <li v-for="page in visiblePages" :key="page">
        <button
          @click="navigateTo(page)"
          :class="{ active: currentPage === page }"
        >{{ page }}</button>
      </li>
    </ul>
    <button
      class="pager__next"
      :disabled="currentPage === numberOfTotalPages"
      :title="translate('lblLinkNext')"
      @click="goToNextPage"
    ><arrow></arrow></button>
  </nav>
</template>

<script>
import Arrow from '../icons/Arrow.vue';

export default {
  props: {
    maxPages: Number,
    pageSize: Number,
    currentPage: Number,
    totalItems: Number,
  },
  computed: {
    numberOfTotalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
    numberOfVisiblePages() {
      return Math.min(this.numberOfTotalPages, this.maxPages);
    },
    visiblePages() {
      const returnValue = [];
      const range = Math.floor(this.numberOfVisiblePages / 2);
      let firstPage = Math.max(this.currentPage - range, 1);
      const lastPage = Math.min(firstPage + this.numberOfVisiblePages - 1, this.numberOfTotalPages);
      firstPage = Math.max(lastPage - this.numberOfVisiblePages + 1, 1);
      for (let i = firstPage; i <= lastPage; i += 1) {
        returnValue.push(i);
      }
      return returnValue;
    },
  },
  methods: {
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.$emit('pageChanged', this.currentPage - 1);
      }
    },
    goToNextPage() {
      if (this.currentPage < this.numberOfTotalPages) {
        this.$emit('pageChanged', this.currentPage + 1);
      }
    },
    navigateTo(page) {
      if (page > 0 && page <= this.numberOfTotalPages) {
        this.$emit('pageChanged', page);
      }
    },
  },
  components: {
    Arrow,
  },
};
</script>

<style lang="scss">
.loyalty-table__pager {
  display: flex;
  justify-content: center;

  .pager {
    &__prev {
      transform: rotate(90deg);
    }

    &__next {
      transform: rotate(-90deg);
    }
  }

  button {
    border: none;
    background: transparent;
    padding: rem(3px) rem(10px);
    &:hover:not(:disabled) {
      color: $color-kws-orange;
    }
    &:disabled {
      cursor: unset;
    }
    svg {
      fill: currentColor;
    }
  }

  ul {
    margin: 0 rem(20px);
    padding: 0;
    list-style: none;
    display: flex;

    li {
      display: flex;
      button {
        font-weight: bold;
        &.active {
          color: $color-kws-orange;
        }
      }
    }
  }
}
</style>
